import { useRecoilValue } from 'recoil';
import { useEffect } from 'react';
import { settingsAtom } from '../atoms/Settings';

export const useFavicon = () => {
  const settings = useRecoilValue(settingsAtom);

  useEffect(() => {
    const url = settings.settingsV1.storefront_favicon;

    if (url) {
      const favicon =
        document.querySelector("link[rel='icon']") ||
        document.createElement('link');
      favicon.setAttribute('rel', 'icon');
      favicon.setAttribute('href', url);
      document.head.appendChild(favicon);
    }
  }, [settings]);
};
